import {
    GET_ALL_QUALIFICATIONS,
    GET_QUALIFICATION_CATEGORIES,
    SET_TABLE,
    SET_PAGE_INDEX,
    SET_ROW_COUNT,
    SET_CATEGORY,
    ADD_QUALIFICATION,
    REMOVE_QUALIFICATION,
    GET_USERS,
    SET_SNACKBAR_STATE,
    GET_CUSTOM_QUALIFICATONS,
    CREATE_CUSTOM_QUALIFICATION,
    EDIT_CUSTOM_QUALIFICATION,
    SET_VIEW_VALID_USERS_MODAL_INFO,
    GET_DEPARTMENTS, GET_AREAS,
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    allQualifications: false,
    qualificationCategories: false,
    currentTable: "required",
    pageIndex: 0,
    rowCount: 50,
    category: "all_categories",
    posting: false,
    users: false,
    postSuccess: false,
    postFail: false,
    customQualifications: false,
    viewValidUsersModalInfo: {
        state: false,
        qualification_id: false
    },
    departments: false,
    areas: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ALL_QUALIFICATIONS.REQUEST: {
            return { ...state, requesting: true, allQualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.FAIL: {
            return { ...state, requesting: false, allQualifications: false };
        }
        case GET_ALL_QUALIFICATIONS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                allQualifications: action.payload
            };
        }
        case GET_QUALIFICATION_CATEGORIES.REQUEST: {
            return {
                ...state,
                requesting: true,
                qualificationCategories: false
            };
        }
        case GET_QUALIFICATION_CATEGORIES.FAIL: {
            return {
                ...state,
                requesting: false,
                qualificationCategories: false
            };
        }
        case GET_QUALIFICATION_CATEGORIES.SUCCESS: {
            return {
                ...state,
                requesting: false,
                qualificationCategories: action.payload
            };
        }
        case SET_TABLE: {
            return {
                ...state,
                currentTable: action.payload
            };
        }
        case SET_PAGE_INDEX: {
            return { ...state, pageIndex: action.payload };
        }
        case SET_ROW_COUNT: {
            return { ...state, rowCount: action.payload };
        }
        case SET_CATEGORY: {
            return { ...state, category: action.payload };
        }
        case ADD_QUALIFICATION.REQUEST: {
            return {
                ...state,
                posting: true,
                postSuccess: false,
                requesting: true,
                postFail: false
            };
        }
        case ADD_QUALIFICATION.FAIL: {
            return {
                ...state,
                posting: false,
                postSuccess: false,
                requesting: false,
                postFail: true
            };
        }
        case ADD_QUALIFICATION.SUCCESS: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: true,
                postFail: false
            };
        }
        case REMOVE_QUALIFICATION.REQUEST: {
            return {
                ...state,
                posting: true,
                requesting: true,
                postSuccess: false,
                postFail: false
            };
        }
        case REMOVE_QUALIFICATION.FAIL: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: false,
                postFail: true
            };
        }
        case REMOVE_QUALIFICATION.SUCCESS: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: true,
                postFail: false
            };
        }
        case GET_USERS.REQUEST: {
            return { ...state, requesting: true, users: false };
        }
        case GET_USERS.FAIL: {
            return { ...state, requesting: false, users: false };
        }
        case GET_USERS.SUCCESS: {
            return { ...state, requesting: false, users: action.payload };
        }
        case SET_SNACKBAR_STATE: {
            return { ...state, postFail: false, postSuccess: false };
        }
        case GET_CUSTOM_QUALIFICATONS.REQUEST: {
            return { ...state, requesting: true, customQualifications: false };
        }
        case GET_CUSTOM_QUALIFICATONS.FAIL: {
            return { ...state, requesting: false, customQualifications: false };
        }
        case GET_CUSTOM_QUALIFICATONS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                customQualifications: action.payload
            };
        }
        case CREATE_CUSTOM_QUALIFICATION.REQUEST: {
            return {
                ...state,
                posting: true,
                requesting: true,
                postSuccess: false,
                postFail: false
            };
        }
        case CREATE_CUSTOM_QUALIFICATION.FAIL: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: false,
                postFail: true
            };
        }
        case CREATE_CUSTOM_QUALIFICATION.SUCCESS: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: true,
                postFail: false
            };
        }
        case EDIT_CUSTOM_QUALIFICATION.REQUEST: {
            return {
                ...state,
                posting: true,
                requesting: true,
                postSuccess: false,
                postFail: false
            };
        }
        case EDIT_CUSTOM_QUALIFICATION.FAIL: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: false,
                postFail: true
            };
        }
        case EDIT_CUSTOM_QUALIFICATION.SUCCESS: {
            return {
                ...state,
                posting: false,
                requesting: false,
                postSuccess: true,
                postFail: false
            };
        }
        case SET_VIEW_VALID_USERS_MODAL_INFO: {
            return { ...state, viewValidUsersModalInfo: action.payload };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }

        default: {
            return { ...state };
        }
    }
};
